import { render, staticRenderFns } from "./CategoryCards.vue?vue&type=template&id=4b96bb8c&scoped=true"
import script from "./CategoryCards.vue?vue&type=script&lang=js"
export * from "./CategoryCards.vue?vue&type=script&lang=js"
import style0 from "./CategoryCards.vue?vue&type=style&index=0&id=4b96bb8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96bb8c",
  null
  
)

export default component.exports